module.exports = __webpack_public_path__ + "media/src/images/icons/instagram_logo-24c331155050e47ede46d02e667fab30.svg";